import { Datagrid, EditButton, List, NumberField, ShowButton, TextField, TextInput, useTranslate } from "react-admin";

import { rowStyles } from "../../utils/rowStyles";
import { ListPagination } from "../../utils/components/ListPagination";

import { ListActions } from "../../common/ListActions";

export function RightHolderList(): JSX.Element {
    const t = useTranslate();

    const filters = [<TextInput key="searchTerms-filter" label={t("resources.rightHolder.fields.name")} source="searchTerms" alwaysOn />];

    return (
        <>
            <List pagination={<ListPagination />} perPage={20} filters={filters} actions={<ListActions />}>
                <Datagrid rowStyle={rowStyles}>
                    <TextField source="name" />
                    <NumberField source="licenseDuration" />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            </List>
        </>
    );
}
